import clsx from "clsx";
import { Input as RAInput, InputProps } from "react-aria-components";
import styles from "./Input.module.css";

const Input = ({ className, ...props }: InputProps) => (
  <RAInput className={clsx(styles.input, className)} {...props} />
);

export default Input;
